import LegalPage from "@/components/site/LegalPage";
import { breadcrumbLd } from "@/lib/jsonld";

export default function AlgemeneVoorwaarden() {
    return (
        <LegalPage
            testId="page-av"
            title="Algemene voorwaarden"
            seo={{
                title: "Algemene voorwaarden | Human Design Studio",
                description:
                    "Algemene voorwaarden van Human Design Studio: diensten, boeken en betalen, prijzen, annuleren en aansprakelijkheid.",
                path: "/algemene-voorwaarden",
                jsonLd: [breadcrumbLd("Algemene voorwaarden", "/algemene-voorwaarden")],
            }}
            sections={[
                {
                    h2: "Diensten",
                    body: [
                        "Human Design Studio biedt Human Design sessies, trajecten en workshops, gericht op inzicht en persoonlijke ontwikkeling. Sessies zijn online (Google Meet); live in Friesland in overleg.",
                    ],
                },
                {
                    h2: "Boeken en betalen",
                    body: [
                        "Je boekt via de website. De betaling verloopt via iDEAL (Mollie). Een afspraak staat vast zodra de betaling is ontvangen. Zolang online betalen nog niet actief is, ontvang je een betaallink en staat de afspraak vast na betaling.",
                    ],
                },
                {
                    h2: "Prijzen",
                    body: ["De prijzen op de website zijn inclusief 21% btw."],
                },
                {
                    h2: "Afspraak verzetten of annuleren",
                    body: [
                        "Je kunt tot 24 uur voor de afspraak kosteloos verzetten of annuleren. Daarna wordt de sessie volledig in rekening gebracht.",
                    ],
                },
                {
                    h2: "Herroepingsrecht",
                    body: [
                        "Bij een online boeking heb je in principe 14 dagen bedenktijd. Omdat een sessie op een met jou afgesproken datum en tijd wordt gereserveerd, geef je bij het boeken toestemming dat de dienst voor dat specifieke moment wordt vastgelegd; het herroepingsrecht vervalt zodra de sessie heeft plaatsgevonden. Kosteloos annuleren of verzetten kan tot 24 uur van tevoren.",
                    ],
                },
                {
                    h2: "Aansprakelijkheid",
                    body: [
                        "Een sessie is gericht op inzicht en persoonlijke ontwikkeling en biedt geen garanties op een bepaald resultaat. Human Design Studio is niet aansprakelijk voor keuzes die je op basis van een sessie maakt.",
                    ],
                },
                {
                    h2: "Contact",
                    body: [
                        "Vragen over deze voorwaarden? Mail naar info@humandesignstudio.nl.",
                    ],
                },
                {
                    body: ["Op deze voorwaarden is Nederlands recht van toepassing."],
                },
            ]}
        />
    );
}
